<template>
  <div>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>Attachment</span>
    </div>
      <a :href="note.attachment.url" target="_blank">
        {{ note.attachment.url }}
      </a>
  </el-card>
  </div>
</template>

<script>
export default {
  name: 'Note',
  props: {
    note: { type: Object, required: true },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Note.vue